var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    rx: 10,
    fill: "#8E55EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.44 19L33.501 24.06L23.563 34C23.2859 34.2771 22.9412 34.4771 22.563 34.58L17.448 35.975C17.3205 36.0096 17.1861 36.0099 17.0584 35.9759C16.9308 35.9418 16.8144 35.8747 16.721 35.7812C16.6276 35.6878 16.5606 35.5713 16.5267 35.4436C16.4928 35.3159 16.4933 35.1815 16.528 35.054L17.922 29.938C18.0251 29.5602 18.225 29.2159 18.502 28.939L28.44 19ZM21.026 25L19.526 26.5H17.25C17.0511 26.5 16.8603 26.421 16.7197 26.2803C16.579 26.1397 16.5 25.9489 16.5 25.75C16.5 25.5511 16.579 25.3603 16.7197 25.2197C16.8603 25.079 17.0511 25 17.25 25H21.026ZM35.378 16.826L35.531 16.97L35.676 17.123C36.282 17.8054 36.6045 18.6935 36.5775 19.6058C36.5505 20.518 36.1762 21.3856 35.531 22.031L34.561 23L29.5 17.94L30.47 16.97C31.1156 16.3249 31.9832 15.9508 32.8954 15.924C33.8077 15.8973 34.6957 16.2199 35.378 16.826ZM25.026 21L23.526 22.5H17.25C17.0511 22.5 16.8603 22.421 16.7197 22.2803C16.579 22.1397 16.5 21.9489 16.5 21.75C16.5 21.5511 16.579 21.3603 16.7197 21.2197C16.8603 21.079 17.0511 21 17.25 21H25.026ZM29.026 17L27.526 18.5H17.25C17.0511 18.5 16.8603 18.421 16.7197 18.2803C16.579 18.1397 16.5 17.9489 16.5 17.75C16.5 17.5511 16.579 17.3603 16.7197 17.2197C16.8603 17.079 17.0511 17 17.25 17H29.026Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.70ed0b0661074cd53376f752c697d68e.svg";
export { ForwardRef as ReactComponent };